module.exports = __webpack_public_path__ + "img/qrcodeaddress.50a8e9a1.svg";